import dataTools from '../tools/data.js'

export default {
  computed: {},

  methods: {
    buildEmptyConfiguration(id) {
      let plotTitle =
        this.mission == null
          ? ''
          : JSON.parse(JSON.stringify(this.mission.name))
      return {
        id: id,
        isDraggable: true,
        x: this.buidDefaultPlotParameter(),
        y: this.buidDefaultPlotParameter(),
        z: this.buidDefaultPlotParameter(),
        multiAxis: [this.buidDefaultPlotParameter()],
        type: 'Line/Scatter chart',
        scatterMode: 'lines',
        scatterShape: 'linear',
        scatterText: this.buidDefaultPlotParameter(),
        autosize: true,
        name: plotTitle,
        displayNonEvolvingFields: false,
        xzero: false,
        yzero: false,
        xlog: false,
        ylog: false,
        width: 1200,
        height: 450,
        data: [],
        targets: [],
        parameters: [],
        filters: [],
        durationSliderOptions: {
          min: 0,
          max: 100,
          step: 0.1
        },
        durationSliderValue: [0, 100]
      }
    },

    buidDefaultPlotParameter() {
      return {
        path: [],
        label: '',
        treevalue: null,
        unit: '',
        unitOptions: [],
        value: null
      }
    },

    getDataName(dataPath) {
      if (dataPath == null || !dataPath.length > 0) {
        return ''
      } else {
        return dataPath[dataPath.length - 1]
      }
    },

    getPlotValues(parameter, data) {
      if (parameter && parameter.path) {
        let scriptConfig =
          this.currentResultsLog != null
            ? this.currentResultsLog.scriptConfig
            : null
        let fieldType = dataTools.getFieldTypeFromPath(
          parameter.path,
          this.type,
          scriptConfig
        )
        let path = Array.isArray(parameter.path)
          ? parameter.path
          : [parameter.path]
        return dataTools
          .getAllValues(data, path)
          .map((value) =>
            dataTools.convertFromSi(fieldType, value, parameter.unit)
          )
          .map((val) => (val === '' ? NaN : val)) // NaN is better for plots than '', crazy legend otherwise
      } else {
        return []
      }
    },

    filterPlotDataFromTimeSlider(values, config) {
      let filteredIndexes = []
      if (values.x && values.x.length > 0) {
        values.x.forEach((el, i) => {
          if (
            el >= config.durationSliderValue[0] &&
            el <= config.durationSliderValue[1]
          ) {
            filteredIndexes.push(i)
          }
        })
      }
      if (values.y && values.x && filteredIndexes.length > 0) {
        values.y = values.y.filter((el, i) => {
          return filteredIndexes.includes(i)
        })
        values.x = values.x.filter((el, i) => {
          return filteredIndexes.includes(i)
        })
      }
    },

    setSurfaceData(trace) {
      let az = []
      for (let y = 0; y < trace.y.length; y++) {
        az[y] = []
        for (let x = 0; x < trace.x.length; x++) {
          if (x === y) {
            az[y][x] = trace.z[y]
          } else {
            az[y][x] = 0
          }
        }
      }
      trace.z = az
    }
  }
}
